var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAddBasic(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 33.156,
    height: 33.156,
    viewBox: "0 0 33.156 33.156",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#c6c6c6",
    d: "M13.17 11.664l10.106-9.995A.963.963 0 0 0 23.3.3a.99.99 0 0 0-1.388-.027L21.887.3l-10.105 9.991L1.676.3A.99.99 0 0 0 .287.32a.963.963 0 0 0 0 1.349l10.106 9.994L.287 21.658a.963.963 0 0 0 0 1.373.99.99 0 0 0 1.388 0l10.106-9.994 10.106 9.994a.99.99 0 0 0 1.388-.024.963.963 0 0 0 0-1.349z",
    transform: "rotate(45 8.243 19.9)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddBasic);
export default __webpack_public_path__ + "static/media/add_basic.53a344bb76cf338a15a5df76592d47bf.svg";
export { ForwardRef as ReactComponent };